import PropTypes from 'prop-types';
// Loader, Save, CheckCircle, AlertCircle, PrimaryButton removed as save logic is moved out
import { Card, CardContent } from '@shared/forms/FormStyles';
import ExtractedRoleCard from './ExtractedRoleCard';
// ValidationError is still used within ExtractedRoleCard, so keep import if needed there, or remove if not used directly here.
// Assuming ValidationError is only used inside ExtractedRoleCard now.

const ExtractedRolesSection = ({
  roles,
  validatedRoles, // Still needed for ExtractedRoleCard logic potentially
  onEditRole,
  onValidateRole,
  onDeleteRole // Add prop for delete callback
}) => {
  if (!roles || roles.length === 0) {
    return null; // Don't render if no roles data
  }

  // Optional: Determine if all roles are valid to enable/disable save button
  // const allRolesValid = validatedRoles.every(isValid => isValid);

  return (
    <Card>
      <div className="border-b border-huntd-secondary/10 bg-white px-6 py-4">
        {/* Removed flex justify-between as save button is gone */}
        <div>
          <h3 className="text-2xl font-bold text-huntd-primary">Extracted Roles</h3>
          <p className="mt-1 text-sm text-huntd-secondary">Review, edit, or delete the extracted roles</p>
        </div>
      </div>
      <CardContent>
        {/* Success and Save Error messages moved out */}

        {/* Role Cards */}
        <div className="space-y-6">
          {roles.map((role, index) => (
            <ExtractedRoleCard
              key={`role-${index}`} // Use a more specific key
              role={role}
              onEdit={(updatedRole) => onEditRole(index, updatedRole)}
              onDelete={() => onDeleteRole(index)} // Pass delete handler
              onValidate={(isValid) => onValidateRole(index, isValid)}
            />
          ))}
          {/* Redundant saveErrors display removed from here */}
        </div>
      </CardContent>
    </Card>
  );
};

ExtractedRolesSection.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  validatedRoles: PropTypes.arrayOf(PropTypes.bool).isRequired, // Keep if ExtractedRoleCard uses it internally via onValidate
  onEditRole: PropTypes.func.isRequired,
  onValidateRole: PropTypes.func.isRequired,
  onDeleteRole: PropTypes.func.isRequired // Add prop type for delete handler
};

export default ExtractedRolesSection;